import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rw-popup',
  templateUrl: './rw-popup.component.html',
  styleUrls: ['./rw-popup.component.scss']
})
export class RwPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
